(function () {
  'use strict';

  angular
    .module('multipleFlightsInRollingSevenDays')
    .controller('multipleFlightsInRollingSevenDaysCtrl', multipleFlightsInRollingSevenDaysCtrl);

  function multipleFlightsInRollingSevenDaysCtrl(CommonMasterData, multipleFlightsInRollingSevenDaysService ,MessageService, $compile,$scope,StorageServices,TabService,applicationConstants) {
    var vm = this;
    vm.ctrlName = 'multipleFlightsInRollingSevenDaysCtrl';

    vm.model = {
      searchPanelToggle: true,
      width: window.screen.width,
      height:window.screen.height,
      searchOnGoing: false,
      totalNumberOfRecords:null,
      searchCriteria: {
        fromDate: null,
        toDate: null,
        crewType: null,
        base:null,
        autoOrManual : null,
        destinations: null,
      },
      masterList: {
        crewTypeList: [],
        baseTypes: [],
        destinationList: [],
        fromDateFormatInvalid: false,
        toDateFormatInvalid: false,
        fromDateAfterToDate: false,
        autoManualList : [{'autoOrManualCode':'M', 'autoOrManualDesc':'Manual'}, {'autoOrManualCode':'A', 'autoOrManualDesc':'Auto'}]

      },
      lastSearchDates:{
        fromDate:null,
        toDate:null
      },
      multipleFlightsInRollingSevenDaysList: [],
      initialSearchDone: false
    };

    vm.clickOnSearch = function () {
      vm.model.searchPanelToggle = !vm.model.searchPanelToggle;
      vm.model.initialSearchDone = false;
    };

    var dataObject = [];
    var hotSettings = [];
    var hot;

    vm.submitSearch = function (params) {
      multipleFlightsInRollingSevenDaysService.searchMultipleFlightsInRollingSevenDays(params,
        function (response) {
          vm.model.lastSearchDates.fromDate = vm.model.searchCriteria.fromDate;
          vm.model.lastSearchDates.toDate = vm.model.searchCriteria.toDate;
          vm.model.multipleFlightsInRollingSevenDaysList = response.multipleFlightsInRollingSevenDaysResponseDTOS;
          vm.model.searchPanelToggle = false;
          vm.model.totalNumberOfRecords = response.multipleFlightsInRollingSevenDaysResponseDTOS.length;
          dataObject = vm.dataObject();
          hotSettings = vm.hotSettings();
          hot = new Handsontable(hotElement, hotSettings);
          $compile(hotElement)($scope);
        },
        function (error) {
          MessageService.error(error[0]);
        }
      );
    };

    vm.dataObject = function () {
      var dataObject = [];

      for (var i in vm.model.multipleFlightsInRollingSevenDaysList) {
        dataObject.push({
          ROW_NUMBER : parseInt(i)+1,
          CREW_NAME: vm.model.multipleFlightsInRollingSevenDaysList[i].crewName,
          CREW_ID: vm.model.multipleFlightsInRollingSevenDaysList[i].crewID,
          CREW_TYPE: vm.model.multipleFlightsInRollingSevenDaysList[i].crewType,
          FIRST_FLIGHT_DESTINATION: vm.model.multipleFlightsInRollingSevenDaysList[i].firstFlightDestination,
          FIRST_FLIGHT_DEPARTURE: vm.model.multipleFlightsInRollingSevenDaysList[i].firstFlightDeparture,
          FIRST_FLIGHT_ARRIVAL: vm.model.multipleFlightsInRollingSevenDaysList[i].firstFlightArrival,
          SECOND_FLIGHT_DESTINATION: vm.model.multipleFlightsInRollingSevenDaysList[i].secondFlightDestination,
          SECOND_FLIGHT_DEPARTURE: vm.model.multipleFlightsInRollingSevenDaysList[i].secondFlightDeparture,
          SECOND_FLIGHT_ARRIVAL: vm.model.multipleFlightsInRollingSevenDaysList[i].secondFlightArrival,
          AUTO: vm.model.multipleFlightsInRollingSevenDaysList[i].autoOrManual,
        })
      }
      return dataObject;
    };

    vm.hotSettings = function () {
      var hotSettings = {
        data: dataObject,
        undo: true,
        redo: true,
        copy: true,
        paste: true,
        manualColumnResize: true,
        copyRowsLimit: 1000000,
        colWidths: [vm.model.width * 0.05, vm.model.width * 0.1, vm.model.width * 0.05, vm.model.width * 0.05, vm.model.width * 0.1, vm.model.width * 0.1, vm.model.width * 0.1, vm.model.width * 0.1, vm.model.width * 0.1, vm.model.width * 0.1, vm.model.width * 0.05],
        columns: [
          {
            data: 'ROW_NUMBER',
            type: 'numeric',
            readOnly: true
          },
          {
            data: 'CREW_NAME',
            renderer: 'html',
            readOnly: true
          }, {
            data: 'CREW_ID',
            type: 'text',
            readOnly: true
          },  {
            data: 'CREW_TYPE',
            type: 'text',
            readOnly: true
          },
          {
            data: 'FIRST_FLIGHT_DESTINATION',
            type: 'text',
            readOnly: true
          },
          {
            data: 'FIRST_FLIGHT_DEPARTURE',
            type: 'text',
            readOnly: true
          },
          {
            data: 'FIRST_FLIGHT_ARRIVAL',
            type: 'text',
            readOnly: true
          },
          {
            data: 'SECOND_FLIGHT_DESTINATION',
            type: 'text',
            readOnly: true
          },
          {
            data: 'SECOND_FLIGHT_DEPARTURE',
            type: 'text',
            readOnly: true
          },
          {
            data: 'SECOND_FLIGHT_ARRIVAL',
            type: 'text',
            readOnly: true
          },
          {
            data: 'AUTO',
            type: 'text',
            readOnly: true
          }],

        stretchH: 'all',
        width: vm.model.width * 0.99,
        autoWrapRow: true,
        height: vm.model.height * 0.7,
        rowHeaders: true,
        colHeaders: [
          '',
          'Crew Name',
          'Crew Id',
          'Crew Type',
          'First Flight Destination',
          'First Flight Departure',
          'First Flight Arrival',
          'Second Flight Destination',
          'Second Flight Departure',
          'Second Flight Arrival',
          'Auto/Manual'
        ]
      };

      return hotSettings;
    };

    var hotElement = document.querySelector('#hot');


    function setDateValidationFlags() {
      if (isDateFormatInvalid(vm.model.searchCriteria.fromDate)) {
        vm.model.masterList.fromDateFormatInvalid = true;
      } else {
        vm.model.masterList.fromDateFormatInvalid = false;
      }
      if (isDateFormatInvalid(vm.model.searchCriteria.toDate)) {
        vm.model.masterList.toDateFormatInvalid = true;
      } else {
        vm.model.masterList.toDateFormatInvalid = false;
      }
    }


    vm.changeSearchField = function (searchParams, flag) {
      setDateValidationFlags();
      if (!vm.model.masterList.toDateFormatInvalid
        && !vm.model.masterList.fromDateFormatInvalid) {
        if (istoDateBeforeFromDate()) {
          vm.model.masterList.fromDateAfterToDate = true;
        } else {
          vm.model.masterList.fromDateAfterToDate = false;

        }
      } else {
        vm.model.masterList.fromDateAfterToDate = false;
      }

    };


    function isDateFormatInvalid(date) {
      if (!!date && !moment(date, "DD/MM/YYYY").isValid()) {
        return true;
      }
      return false;
    }

    function istoDateBeforeFromDate() {
      return moment(vm.model.searchCriteria.toDate, "DD/MM/YYYY")
        .isBefore(
          moment(vm.model.searchCriteria.fromDate,
            "DD/MM/YYYY"));
    };

    (function () {
      CommonMasterData.getCrewTypeList(function (crewTypeList) {
        vm.model.masterList.crewTypeList = crewTypeList;
      }, function () {
        console.log('Crew Type list retrieval error');
      });

    })();

    (function () {
      CommonMasterData.getCrewBaseList(function (crewBase) {
        vm.model.masterList.baseTypes = crewBase;
      }, function () {
        console.log('Crew Base retrieval error');
      });

    })();

    (function () {
      CommonMasterData.getAirportList(function (destinationList) {
        vm.model.masterList.destinationList = destinationList;
      }, function () {
        console.log('Airport list retrieval error');
      });

    })();
  }
}());
